import { createSelector } from '@ngrx/store';

import { wizzardState } from '../root';

export const getWizzardSimpleItemQuantity = createSelector(wizzardState, (wizzard) => (wizzard.itemsSimple ? wizzard.itemsSimple.Quantity : null));
